import React from 'react';
import { Flex, Image, useColorModeValue } from '@chakra-ui/react';
import { HSeparator } from 'components/separator/Separator';
import CompanyLogo from 'assets/img/main_logo copy.png';

export function SidebarBrand({ collapsed }) {
  let logoColor = useColorModeValue('navy.700', 'white');

  return (
    <Flex align="center" direction="column" w="100%">
      <Image
        src={CompanyLogo}
        alt="Company Logo"
        h={collapsed ? '32px' : '56px'}
        w={collapsed ? '32px' : '175px'}
        objectFit="contain"
        my={collapsed ? '20px' : '32px'}
        transition="all 0.2s ease"
      />

      {!collapsed && <HSeparator mb="20px" />}
    </Flex>
  );
}

export default SidebarBrand;
